"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATAFORMA_CONSOLIDADO_SMS = void 0;
exports.PLATAFORMA_CONSOLIDADO_SMS = {
    TELESTAR: 1,
    'SMS 2.0': 2,
    'SMS NG': 3,
};
